<template lang='pug'>
  app-layout
    v-flex(xs12)
      v-flex.py-0.elevation-1(fluid)
        v-layout(row-wrap)
          v-flex(xs3)
            v-divider
            v-list.sidebar.fill-height
              menu-item(v-for="menu in accountManagement.menuItems" :properties="menu")
          v-flex(xs9)
            v-container(id="account-mgmt-content")
              v-card
                v-card-text
                  router-view
</template>
<script>
import MenuItem from './components/MenuItem';
import { ACCOUNT_MANAGEMENT } from './config';

export default {
  name: 'AccountManagement',
  components: {
    MenuItem,
  },
  data() {
    return {
      accountManagement: ACCOUNT_MANAGEMENT,
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      var header = document.getElementsByClassName("header-acct")[0];
      var sticky = header.offsetTop;

      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    },
  },
};
</script>
    
<style lang="scss" scoped>
.sidebar {
  min-height: 100vh;
  background-color: #ededed;
  margin: 0 auto;
}
</style>
